import { createFileRoute } from '@tanstack/react-router'
import { FlashSalesLayout } from '@/features/flash-sales/components'

export const Route = createFileRoute('/_authenticated/flash-sales')({
  component: FlashSalesLayout,
})
